import React from 'react';
import { Link } from 'react-router-dom';
import useOperationalHealth from '../../hooks/useOperationalHealth';

function OperationalHealthIndicator() {
    const { health } = useOperationalHealth(60000);

    if (!health || health.status === 'green') return null;

    const isRed = health.status === 'red';
    const count = health.issues ? health.issues.length : 0;
    const tooltip = health.issues
        ? health.issues.map(i => `• ${i.text}`).join('\n')
        : '';

    return (
        <li className='nav-item mt-2 mb-1'>
            <Link to='/dashboard'
                className={`nav-link py-1 d-flex align-items-center gap-2 rounded ${isRed ? 'text-danger' : 'text-warning'}`}
                style={{ fontSize: 12 }}
                title={tooltip}>
                <span
                    className={`d-inline-block rounded-circle flex-shrink-0 ${isRed ? 'bg-danger' : 'bg-warning'}`}
                    style={{ width: 8, height: 8 }} />
                <span className='sidebar-text'>
                    {count} {count === 1 ? 'pendência' : 'pendências'} operacional{count !== 1 ? 'is' : ''}
                    <span className='d-block' style={{ fontSize: 10, opacity: 0.8 }}>ver no Dashboard →</span>
                </span>
            </Link>
        </li>
    );
}

export default OperationalHealthIndicator;
